import React from 'react';
import { connect } from 'react-redux';
import Commons from '../../../commons/commons';
import notesVoucher from '../vouchers-notes';
import './voucher-info.css';

function createSkeleton() {
  return (
    <div className='skeleton' style={{ width: '100%', height: 300, background: '#eaeaea', color: '#000', marginBottom: 35 }}>
      <div className='container' />
    </div>
  );
}

function checkPayments(promotionsList = []) {
  const ahora12 = promotionsList.filter(
    (promo) => promo.bank.denomination === 'AHORA 12',
  )[0]; // if exist true else false
  const ahora18 = promotionsList.filter(
    (promo) => promo.bank.denomination === 'AHORA 18',
  )[0]; // if exist true else false

  return [ahora12, ahora18];
}

function pricePerInstallments(interests, price, installments) {
  return (((price * interests) / 100) + price) / installments;
}

const VoucherInfo = (props) => {
  const { voucherOfertas, indexSelected, onNightsChange, promotions } = props;
  if (!voucherOfertas) {
    return createSkeleton();
  }
  const loadingPromotions = (!promotions || promotions === []);
  const [ahora12, ahora18] = checkPayments(promotions);
  const oferta = voucherOfertas[indexSelected];

  return (
    <div className='voucher-info color-dinamico-fondo'>
      <div className='container'>
        <div className='row'>
          <div className='col-md-4'>
            <div className='info-text'>
              <h2 className='title-primary'>
                {' '}
                Elegí la cantidad de noches de tu Open Voucher
                {oferta.tipoVoucher.descripcion}
              </h2>
              <div className='custom-select type'>
                <div className='custom-caret' tabIndex='-1' />
                <select
                  onChange={(e) => onNightsChange(e.target.value)}
                  value={indexSelected}
                  className='form-control type-selector'
                  name='noches'
                >
                  {voucherOfertas.map((oferta, index) => (
                    <option key={oferta.usoVoucher.cantidadUsos} value={index}>
                      {oferta.usoVoucher.cantidadUsos}
                      {' '}
                      noches
                    </option>
                  ))}
                </select>
              </div>
              <h4 className='title-secondary'>
                Open Voucher
                {oferta.tipoVoucher.descripcion}
                {' '}
                para 2 personas en los alojamientos disponibles
              </h4>
            </div>
          </div>
          {(!loadingPromotions && ahora12) || (!loadingPromotions && ahora18) ? (
            <div className='col-md-4'>
              <div className='financiacion-container'>
                <div className='financiacion-cuadro'>
                  <div className='title'>
                    Pagá en cuotas
                  </div>
                  <div className='opciones'>
                    {ahora12 && (
                      <div className='item'>
                        <img
                          src='https://res.mundigea.com.ar/img/recursos/12.jpg'
                          alt=''
                          style={{ display: 'block', width: '100%', height: 90, background: '#fff', objectFit: 'contain' }}
                        />
                        <div className='rest text-center'>
                          <div className='label-rest'>Cuotas de</div>
                          <div className='precio'>
                            {oferta.moneda.descripcion}
                            {' '}
                            {
                              Commons.numberFixedToMoney(
                                pricePerInstallments(ahora12.interests, oferta.importe, ahora12.installments),
                              )
                            }
                          </div>
                        </div>
                      </div>
                    )}
                    {ahora18 && (
                      <div className='item'>
                        <img
                          src='https://res.mundigea.com.ar/img/recursos/18.jpg'
                          alt=''
                          style={{ display: 'block', width: '100%', height: 90, background: '#fff', objectFit: 'contain' }}
                        />
                        <div className='rest text-center'>
                          <div className='label-rest'>Cuotas de</div>
                          <div className='precio'>
                            {oferta.moneda.descripcion}
                            {' '}
                            {
                              Commons.numberFixedToMoney(
                                pricePerInstallments(ahora18.interests, oferta.importe, ahora18.installments),
                              )
                            }
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className='col-md-4'>Cargando</div>
          )}
          <div className='col-md-4'>
            <div className='precio-total-container'>
              <div className='precio-espacio'>
                <div className='precio'>
                  <div className='number'>
                    {oferta.moneda.descripcion}
                    {' '}
                    {Commons.numberToMoney(oferta.importe)}
                  </div>
                  <div className='info'>Precio Contado</div>
                </div>
                <a
                  className='btn-buy'
                  href={`${process.env.RAZZLE_URL_PATH}/open-voucher/checkout/${oferta.tipoVoucher.id}/${oferta.id}`}
                  target='_black'
                  rel='noopener noreferrer'
                >
                  Comprar
                </a>
                {notesVoucher[oferta.tipoVoucherId] && (
                  <div className='nota'>
                    IMPORTANTE:
                    {' '}
                    {notesVoucher[oferta.tipoVoucherId]}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(
  (state) => ({
    promotions: state.promociones.promociones,
  }),
  null,
)(VoucherInfo);
